export const LANDING = '/';
export const EXPLORE = '/explore';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';
export const SIGN_OUT = '/signout';
export const PROFILE = '/profile';
export const PROFILE_ID = '/profile/:id';
export const ACCOUNT = '/account';
export const POSTING = '/posting';
